//  declare global {
//     interface Window {
//         CryptoJS: any
//     }
//   }
declare const require: any;
const CryptoJS = require("crypto-js");
export class encoder {
  jwt(data: any, secret: string = "") {
    const header = {
      alg: "HS256",
      typ: "JWT",
    };
    let stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
    let encodedHeader = base64url(stringifiedHeader);
    let stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
    let encodedData = base64url(stringifiedData);
    let token = encodedHeader + "." + encodedData;
    //Firma del token
    let signature = CryptoJS.HmacSHA256(token, secret);
    signature = base64url(signature);
    let signedToken = token + "." + signature;
    return signedToken;
  }
  sha256(label: string) {
    const hash = CryptoJS.SHA256(label);
    const texthash = hash.words.toString();
    return texthash;
  }
}
//Base que encripta
function base64url(source: any) {
  // Encode in classical base64
  let encodedSource = CryptoJS.enc.Base64.stringify(source);
  // Remove padding equal characters
  encodedSource = encodedSource.replace(/=+$/, "");
  // Replace characters according to base64url specifications
  encodedSource = encodedSource.replace(/\+/g, "-");
  encodedSource = encodedSource.replace(/\//g, "_");
  return encodedSource;
}